import { makeRequest } from 'utils/requestLogger';

export default (payload) =>
  makeRequest('post', '/api/users/complete-registration', payload);



// WEBPACK FOOTER //
// ./src/app/services/account/completeRegistration.js